export var InputStyle = {
    roundedStyle: {
        default: {
            borderRadius: '6px',
            height: '47px',
            border: '1px solid #434175',
            paddingLeft: '17px',
        },
        focus: {
            border: '1px solid #F5821F'
        }
    },
    lineStyle: {
        default: {
            border: '0',
            borderBottom: '1px solid #d3d3d3',
            fontSize: '.75rem',
            color: '#212529',
            borderRadius: '0',
            paddingLeft: '3px',
            height: '35px',
        },
        focus: {
            borderBottom: '1px solid #F5821F',
        }
    }
};
//# sourceMappingURL=style.js.map